import axios, { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import { getAccessToken, getRefreshToken } from "../auth/authBridge";

type RetriableRequestConfig = InternalAxiosRequestConfig & { _retry?: boolean };

const instance = axios.create();

instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAccessToken();
    if (token) {
      if (!config.headers) {
        config.headers = new AxiosHeaders();
      }
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error?.config as RetriableRequestConfig | undefined;

    if (!originalRequest) {
      return Promise.reject(error);
    }

    const isUnauthorized = error.response != null && error.response.status === 401;
    const alreadyRetried = originalRequest._retry === true;

    if (!isUnauthorized || alreadyRetried) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;
    const newToken = await getRefreshToken();

    if (newToken) {
      if (!originalRequest.headers) {
        originalRequest.headers = new AxiosHeaders();
      }
      originalRequest.headers.set("Authorization", `Bearer ${newToken}`);
      return instance(originalRequest);
    }

    window.location.href = "/";
    return Promise.reject(error);
  },
);

export default instance;
